import { routes } from "../config";

export const renderRoutes = (renderer, renderChildren = true) => routes.map((r) => {
    const routeList = [];
    routeList.push(renderer(r));
    renderChildren && r.children?.forEach(rc => routeList.push(renderer(rc)));
    return routeList;
});

export const renderFilteredRoutes = (renderer, predicate) => routes.filter(predicate).map((r) => renderer(r));